/* Tama & Co. theme scripts — small, dependency-free */
(function () {
  'use strict';

  // Close open drawers (menu, filters) with Escape
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details.menu-drawer[open], details.drawer[open]').forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.focus();
    });
  });

  // Click on the dimmed backdrop closes a drawer
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details.menu-drawer[open], details.drawer[open]').forEach(function (d) {
      if (e.target === d || !d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var d = btn.closest('details');
      if (d) d.removeAttribute('open');
    });
  });

  // Sort select submits its form
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () { select.form.submit(); });
  });

  // Variant picker
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var json = root.querySelector('[data-variants]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var addBtn = root.querySelector('[data-add]');
    var addText = addBtn ? addBtn.getAttribute('data-add-text') : '';
    var radios = root.querySelectorAll('input[data-opt]');

    function selected() {
      var opts = [];
      radios.forEach(function (r) { if (r.checked) opts[Number(r.dataset.opt)] = r.value; });
      return opts;
    }

    function update() {
      var opts = selected();
      root.querySelectorAll('[data-opt-label]').forEach(function (el) {
        el.textContent = opts[Number(el.dataset.optLabel)] || '';
      });
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = match.price;
      if (compareEl) {
        compareEl.innerHTML = match.compare || '';
        compareEl.hidden = !match.compare;
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addText : 'Sold out';
      }
      if (match.media) {
        var slide = root.querySelector('[data-media-id="' + match.media + '"]');
        if (slide) {
          var gallery = slide.parentElement;
          if (gallery && gallery.scrollWidth > gallery.clientWidth) {
            gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
          }
        }
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }

    radios.forEach(function (r) { r.addEventListener('change', update); });
  });

  // Product recommendations (loaded via Section Rendering API)
  document.querySelectorAll('[data-recommendations-url]').forEach(function (el) {
    fetch(el.getAttribute('data-recommendations-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-recommendations-url]');
        if (fresh && fresh.innerHTML.trim().length) {
          el.innerHTML = fresh.innerHTML;
        } else {
          var section = el.closest('.shopify-section');
          if (section) section.hidden = true;
        }
      })
      .catch(function () {});
  });
})();
